var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNextArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13547_15141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9227 8.22557C14.0512 8.10252 14.125 7.93025 14.125 7.74979C14.125 7.56932 14.0512 7.39979 13.9227 7.274L9.11016 2.68025C8.84766 2.42869 8.43203 2.43963 8.1832 2.70213C7.93438 2.96463 7.94258 3.38025 8.20508 3.62908L11.8309 7.09354L2.53125 7.09354C2.16758 7.09354 1.875 7.38611 1.875 7.74979C1.875 8.11346 2.16758 8.40604 2.53125 8.40604H11.8309L8.20234 11.8678C7.93984 12.1193 7.93164 12.5322 8.18047 12.7947C8.4293 13.0572 8.84492 13.0654 9.10742 12.8166L13.9199 8.22283L13.9227 8.22557Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13547_15141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 14,
    fill: "white",
    transform: "matrix(0 -1 1 0 1 13)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNextArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/next_arrow.da94fa2ab237a41ad51a233f12afc696.svg";